import React, { Component } from 'react';
import { navigateTo } from 'gatsby-link';
import IntroWithButton from '../components/global/IntroWithButton';
import Era from '../components/timeline/Era';
import style from './Timeline.module.scss';
import Observer from 'react-intersection-observer';
import Helmet from 'react-helmet';
import jump from 'jump.js';
import {
  SSL_OP_CISCO_ANYCONNECT,
  POINT_CONVERSION_COMPRESSED,
} from 'constants';
class Timeline extends Component {
  timelineData = this.props.data.timeline;
  targetIndex = -1;
  state = {
    reveal: false,
    loadedEraIndices: [],
    eraMounted: [],
  };

  handleOnChange = (oberver, index) => {
    if (oberver && !this.state.loadedEraIndices.includes(index)) {
      this.handleEraLoaded(index);
    }
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ reveal: true });
    }, 300);
    this.props.resetDisplaySettings();
    this.props.setHeaderTransparent(false);
    // console.log(this.timelineData);
  }

  handleEraSkipped = () => {
    const eraSkip = this.props.registerEraSkip();
    console.log(eraSkip);
  };

  handleEraMounted = index => {
    if (this.state.eraMounted.includes(index)) return;

    this.setState({
      eraMounted: [...this.state.eraMounted, index],
    });

    if (this.targetIndex === this.props.targetEra.index) {
      this.targetIndex = -1;
      this.props.targetEra.skipTo();
    }
  };

  handleEraLoaded = (index, cb = () => {}) => {
    let tempIndices = this.state.loadedEraIndices;

    tempIndices.push(index);

    this.setState({
      loadedEraIndices: tempIndices,
    });
  };

  handleGoToAbout = () => {
    const path = this.props.settingsContent.menu.filter(
      data => data.title === 'About'
    )[0].path;
    navigateTo(path);
  };

  componentWillUnmount() {
    this.props.setHeaderTransparent(true);
  }

  componentWillReceiveProps(nextProps) {
    let bothNegativeOne =
      this.targetIndex === -1 && this.props.targetEra.index === -1;
    if (this.targetIndex !== this.props.targetEra.index || bothNegativeOne) {
      this.targetIndex = nextProps.targetEra.index;
      if (this.props.targetEra.index !== nextProps.targetEra.index) {
        if (
          this.state.eraMounted.includes(this.targetIndex) ||
          this.state.loadedEraIndices.includes(this.targetIndex)
        ) {
          this.targetIndex = -1;
          nextProps.targetEra.skipTo();
        } else {
          for (let i = 0; i <= nextProps.targetEra.index; i++) {
            this.handleEraLoaded(i);
          }
        }
      } else if (this.props.targetEra.index === nextProps.targetEra.index) {
        this.targetIndex = -1;
        this.props.targetEra.skipTo();
      }
    }
  }

  render() {
    const lastHeader = this.timelineData.eras.filter(
      (era, index) => era.add_link_to_about_page === true
    );

    const filteredEras = this.timelineData.eras.filter(
      (era, index) => !era.add_link_to_about_page
    );

    return (
      <div
        className={`${style.timeline} ${
          this.props.transition && this.props.transition.status === 'exiting'
            ? style.exiting
            : ''
        }`}
      >
        <Helmet title={`Timeline | The House on Henry Street`} />

        <div className={style.chapterInfoWrapper}>
          <IntroWithButton
            title={this.timelineData.title}
            subtitle={this.timelineData.description}
            scrollIndicator={true}
            scrollClass={'.timeline-start'}
            scrollOffset={-90}
            doSplitText={true}
            startHidden
            show={!this.props.introIsShowing && this.state.reveal}
          />
        </div>

        {this.timelineData &&
          filteredEras.map((era, i) => {
            return (
              !era.add_link_to_about_page && (
                <Observer
                  onChange={e => this.handleOnChange(e, i)}
                  key={`era-${i}-${era.starting_year}`}
                  className={style.eraGrid}
                  rootMargin={'50% 0% 50% 0%'}
                >
                  {this.state.loadedEraIndices.includes(i) ? (
                    <Era
                      index={i}
                      getInViewIndex={this.handleEraLoaded}
                      getIsMountedIndex={this.handleEraMounted}
                      lastHeader={
                        i === filteredEras.length - 1 ? lastHeader[0] : null
                      }
                      goToAbout={this.handleGoToAbout}
                      inLoadedArray={this.state.loadedEraIndices.includes(i)}
                      data={era}
                    />
                  ) : (
                    <div
                      id={`years${era.starting_year}`}
                      style={{
                        display: 'block',
                        height: '100vh',
                        width: '100%',
                      }}
                    />
                  )}
                </Observer>
              )
            );
          })}
      </div>
    );
  }
}

export default Timeline;

export const timelineQuery = graphql`
  query TimelineByPath($path: String!) {
    timeline: dataJson(path: { eq: $path }) {
      title
      description
      eras {
        title
        watermark
        short_description
        starting_year
        ending_year
        add_link_to_about_page
        image {
          url
          alt
        }
        era_content {
          era_type
          title
          body
          attribution
          image {
            url
            alt
          }
          grid_contents {
            grid_item_type
            title
            body
            color_toggle
            vimeo_id
            youtube_id
            video_source
            video_file {
              # id
              url
            }
            poster {
              # id
              url
              # sizes {
              #   thumbnail
              #   medium
              #   medium_large
              #   large
              # }
            }
            images {
              url
              alt
              height
              width
              sizes {
                #medium
                medium_large
                large
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/timeline.js